import { render, staticRenderFns } from "./returkiriman.vue?vue&type=template&id=5cc0aaf2"
import script from "./returkiriman.vue?vue&type=script&lang=js"
export * from "./returkiriman.vue?vue&type=script&lang=js"
import style0 from "./returkiriman.vue?vue&type=style&index=0&id=5cc0aaf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports